import styled from '@emotion/styled';
import _ from 'lodash';
import { Variables } from '../variables';

interface IMenuProps {
    activatorRect: ClientRect;
    viewportRect: ClientRect;
    menuRect?: ClientRect;
    align?: 'left' | 'right';
    verticalAlign?: 'top' | 'bottom' | 'auto';
    isOpen?: boolean;
}

export const Menu = styled.div<IMenuProps>`
    position: absolute;
    display: block;
    padding: 8px 0px;

    user-select: none;
    z-index: 1301;

    border-radius: ${Variables.Rounded.small};
    background-color: ${Variables.Colors.white};

    ${(props: IMenuProps): string => {
        if (props.isOpen !== false) {
            return `box-shadow: ${Variables.Shadows.large}, ${Variables.Shadows.border};`;
        }
        return '';
    }}

    ${(props: IMenuProps): string => {
        const vy = props.viewportRect.top;
        const ay = props.activatorRect.top;
        const ah = props.activatorRect.height;
        const gap = 8;
        const visualHeight = typeof window !== 'undefined' ? window.innerHeight : props.viewportRect.height;
        const spaceBelow = visualHeight - ay - ah - gap;
        const spaceAbove = ay - gap;
        const mh = props.menuRect?.height ?? 0;

        const hasRoomUnder = mh > 0 ? spaceBelow >= mh : spaceBelow >= spaceAbove;
        const openBelow =
            props.verticalAlign === 'bottom' ||
            (props.verticalAlign !== 'top' && (props.verticalAlign !== 'auto' || hasRoomUnder));

        if (openBelow) {
            return `
                top: ${-vy + ay + ah}px;
                margin-top: ${gap}px;
            `;
        }

        return `
            top: ${-vy + ay - (mh || spaceAbove)}px;
            margin-top: -${gap}px;
        `;
    }}

    ${(props: IMenuProps): string => {
        const vx = props.viewportRect.left;
        const vw = props.viewportRect.width;
        const aw = props.activatorRect.width;
        const ax = props.activatorRect.left;
        const mw = _.get(props, 'menuRect.width', 0);
        
        const hasRoomOnRight = ax + mw <= vw;
        
        switch (props.align) {
            case 'right':
                return `right: ${-vx + vw - ax - aw}px;`;
            case 'left':
            default:
                if (!hasRoomOnRight && ax + aw > mw) {
                    return `right: ${-vx + vw - ax - aw}px;`;
                }
                return `left: ${-vx + ax}px;`;
        }
    }}
`;
